/**
 * Safely extracts a human-readable message from various response formats.
 *
 * Handles:
 * - Strings like "{message=Something went wrong}"
 * - Regular strings ("Something went wrong")
 * - Axios error responses (error.response.data.message)
 * - Fallback to "Operation failed"
 */

export function extractMessage(raw: any): string {
  if (!raw) return "Operation failed";

  if (typeof raw === "object" && raw.message) return raw.message;

  if (typeof raw === "string") {
    // Try to extract message from "{message=...}"
    const match = raw.match(/message=(.*?)(?:}|$)/);
    let msg = match ? match[1].trim() : raw.trim();

    // Remove trailing numeric codes like ": 809" or "- 123"
    msg = msg.replace(/[:\-]\s*\d+\s*$/, "").trim();

    return msg;
  }

  return String(raw);
}
